import { useCallback, useEffect, useState } from 'react';

export interface MenuPosition { x: number; y: number }

export function useContextMenu(): {
  position: MenuPosition | null;
  openAt: (event: { clientX: number; clientY: number; preventDefault: () => void }) => void;
  close: () => void;
} {
  const [position, setPosition] = useState<MenuPosition | null>(null);

  const openAt = useCallback((event: {
    clientX: number; clientY: number; preventDefault: () => void;
  }) => {
    event.preventDefault();
    setPosition({ x: event.clientX, y: event.clientY });
  }, []);

  const close = useCallback(() => { setPosition(null); }, []);

  useEffect(() => {
    if (!position) return;
    const dismiss = (): void => { setPosition(null); };
    const onKey = (e: KeyboardEvent): void => { if (e.key === 'Escape') setPosition(null); };
    // capture 로 잡아야 메뉴 항목 클릭보다 먼저 닫히지 않는다 (click 은 버블 단계에서 처리)
    window.addEventListener('click', dismiss);
    window.addEventListener('resize', dismiss);
    window.addEventListener('scroll', dismiss, true);
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('click', dismiss);
      window.removeEventListener('resize', dismiss);
      window.removeEventListener('scroll', dismiss, true);
      window.removeEventListener('keydown', onKey);
    };
  }, [position]);

  return { position, openAt, close };
}
